import React from 'react';
import "./Services.css";
import {services} from "../../constants/data";
import { FaHome, FaShoppingCart, FaHammer, FaExchangeAlt, FaUmbrellaBeach, FaHandshake } from 'react-icons/fa';

const Services = () => {
  const icons = [FaHome, FaShoppingCart, FaHammer, FaExchangeAlt, FaUmbrellaBeach, FaHandshake];

  return (
    <div className='services section-p' id = "services">
        <div className='container'>
            <div className='services-content'>
                <div className='section-title'>
                    <h3 className='text-brown'><span className='text-dark'>servicios</span></h3>
                    <p className='text'>Ofrecemos las soluciones adecuadas para tu negocio inmobiliario.</p>
                </div>

                <div className='services-list grid'>
                    {
                        services.map((service, index) => {
                            const IconComponent = icons[index];
                            return (
                                <div className='services-item text-center' key = {index}>
                                    <div className='services-item-img'>
                                        <IconComponent size={50} className="mx-auto text-brown" />
                                    </div>
                                    <div className='services-item-text'>
                                        <h4 className='fs-22 fw-5 op-08'>{service.title}</h4>
                                        <p className='text mx-auto'>{service.paragraph}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    </div>
  )
}

export default Services